import { MDSDropdown } from '@marqvision/mds-v2';
import { useShipFrom } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';

export const ShipFromFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const shipFrom = useShipFrom();

  return (
    <MDSDropdown
      label="Ship from"
      value={shipFrom.selected}
      list={shipFrom.list}
      isDisabled={shipFrom.disabled}
      isLoading={shipFrom.isFetching}
      onChange={shipFrom.select}
      modules={['search', { type: 'filter-button', size }]}
    />
  );
};
